/*
 * @Descripttion: 
 * @version: 
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-07-15 17:29:43
 * @LastEditors: linxi
 * @LastEditTime: 2025-07-16 16:22:21
 */
import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../../app/applicationSlice'
import { RootThunkApi } from '../../../app/store'
import {
  AcceptParams,
  BusinessManagementListParams,
  getAddCompanyRecord,
  getBusinessAccept,
  getBusinessListExport,
  getBusinessManagementDetail,
  getBusinessManagementList,
  getFirstsellcompanyrecordBaseDelete,
  getFirstsellcompanyrecordBaseSubmit,
  SubmitParams,
} from '../../../services/firstTimeBusinessManagement'

// 列表
export const getBusinessManagementListAsync = createAsyncThunk<
  void,
  BusinessManagementListParams,
  RootThunkApi<void>
>('businessManagement/getBusinessManagementListAsync', async (params, api) => {
  return sendAsync(getBusinessManagementList(params), api)
})

// 新增首营企业登记表
export const getAddCompanyRecordAsync = createAsyncThunk<
  void,
  any,
  RootThunkApi<void>
>('businessManagement/getAddCompanyRecordAsync', async (params, api) => {
  return sendAsync(getAddCompanyRecord(params), api)
})

// 详情
export const getBusinessManagementDetailAsync = createAsyncThunk<
  void,
  any,
  RootThunkApi<void>
>(
  'businessManagement/getBusinessManagementDetailAsync',
  async (params, api) => {
    return sendAsync(getBusinessManagementDetail(params), api)
  }
)

// 审批
export const getBusinessAcceptAsync = createAsyncThunk<
  void,
  AcceptParams,
  RootThunkApi<void>
>('businessManagement/getBusinessAcceptAsync', async (params, api) => {
  return sendAsync(getBusinessAccept(params), api)
})

// 保存编辑
export const getFirstsellcompanyrecordBaseSubmitAsync = createAsyncThunk<
  void,
  SubmitParams,
  RootThunkApi<void>
>(
  'businessManagement/getFirstsellcompanyrecordBaseSubmitAsync',
  async (params, api) => {
    return sendAsync(getFirstsellcompanyrecordBaseSubmit(params), api)
  }
)

//导出
export const getBusinessListExportAsync = createAsyncThunk<
  void,
  BusinessManagementListParams,
  RootThunkApi
>('businessManagement/getBusinessListExport ', async (params, api) => {
  return sendAsync(getBusinessListExport(params), api)
})

// 删除
export const getFirstsellcompanyrecordBaseDeleteAsync = createAsyncThunk<
  void,
  any,
  RootThunkApi<void>
>(
  'businessManagement/getFirstsellcompanyrecordBaseDeleteAsync',
  async (params, api) => {
    return sendAsync(getFirstsellcompanyrecordBaseDelete(params), api)
  }
)
